import React from 'react'

export interface CallToActionBoxProps {
  icon: React.ReactNode
  children: React.ReactNode
  actions?: React.ReactNode
}

export const CallToActionBox: React.FC<CallToActionBoxProps> = ({ icon, children, actions }) => (
  <div className='pro-closest-shadow'>
    <div className='cta-box'>
      <div className='cta-box-icon'>
        {icon}
      </div>
      <div className='cta-box-content'>
        {children}
      </div>
    </div>
    {
      actions !== undefined && (
        <div className='cta-box-actions'>
          {actions}
        </div>
      )
    }
  </div>
)
